import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { NavLink } from 'react-router-dom';

const AdminMenu = () => {
    return (
        <div className="side-menu flex flex-col xl:w-[250px] bg-slate-800 text-slate-100 leading-7 h-screen color-scheme-dark">
            <div className="overflow-auto p-3">

                <div className="pb-3 pt-3 flex items-center">
                    <span className="text-slate-400">Admin</span>
                </div>

                <NavLink
                    to={ `/admin` }
                    end={ true }
                    className="flex text-left border-b border-slate-700 pb-[3px] mb-[3px] flex-1"
                    onClick={ closeMobileMenu }>Home 🏠</NavLink>

                <NavLink
                    to={ `/admin/file-system-viewer` }
                    className="flex text-left border-b border-slate-700 pb-[3px] mb-[3px] flex-1"
                    onClick={ closeMobileMenu }>File System Viewer 💾</NavLink>

                <NavLink
                    to={ `/admin/users` }
                    className="flex text-left border-b border-slate-700 pb-[3px] mb-[3px] flex-1"
                    onClick={ closeMobileMenu }>Users 👤</NavLink>

            </div>
        </div>
    )
};

export default AdminMenu;